import KformComponent from '../kform-component';

export default class ButtonComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentButton | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.action = settings?.action ?? 'submit';
		this.autofocus = settings?.autofocus ?? false;
		this.block = settings?.block ?? false;
		this.disabled = settings?.disabled ?? false;
		this.disableOnInvalid = settings?.disableOnInvalid ?? false;
		this.input = true;
		this.leftIcon = settings?.leftIcon ?? '';
		this.rightIcon = settings?.rightIcon ?? '';
		this.size = settings?.size ?? 'md';
		this.theme = settings?.theme ?? 'primary';
	}
}
